var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2248 9.70379L12.0895 0.626931C11.6221 0.159513 10.8626 0.159513 10.3951 0.626931L1.25984 9.70379C0.788989 10.1712 0.785546 10.9342 1.25296 11.405C1.48667 11.6422 1.79603 11.759 2.10535 11.759C2.41467 11.759 2.71711 11.6422 2.95425 11.4085L10.0377 4.36972V20.0626C10.0377 20.7259 10.5773 21.2655 11.2406 21.2655C11.9039 21.2655 12.4435 20.7259 12.4435 20.0626V4.36972L19.527 11.4085C19.9978 11.8759 20.7608 11.8759 21.2282 11.4016C21.6956 10.9273 21.6957 10.1678 21.2214 9.70035L21.2248 9.70379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickTopArrow);
export default __webpack_public_path__ + "static/media/quick_top_arrow.3b0a5b86f6a8b5b29e3084d36c8c5ae4.svg";
export { ForwardRef as ReactComponent };